module.exports = __webpack_public_path__ + "static/media/profile-setting-red.8161884a.svg";